"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Partners() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    once: true,
    threshold: 0.15
  });
  const primaryLogos = [{
    name: "Healthcare Systems",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717971/img/healthcare_partner.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717971/img/healthcare_partner.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717971/img/healthcare_partner.png-wvc-sizes"
  }, {
    name: "Legal Firms",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717971/img/legal_partner.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717971/img/legal_partner.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717971/img/legal_partner.png-wvc-sizes"
  }, {
    name: "Financial Institutions",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717971/img/finance_partner.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717971/img/finance_partner.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717971/img/finance_partner.png-wvc-sizes"
  }, {
    name: "Real Estate Groups",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717971/img/real_estate_partner.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717971/img/real_estate_partner.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717971/img/real_estate_partner.png-wvc-sizes"
  }, {
    name: "Construction Firms",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717971/img/construction_partner.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717971/img/construction_partner.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717971/img/construction_partner.png-wvc-sizes"
  }, {
    name: "Retail Networks",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717971/img/retail_partner.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717971/img/retail_partner.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717971/img/retail_partner.png-wvc-sizes"
  }];
  const secondaryClients = [{
    name: "E-COMMERCE"
  }, {
    name: "LOGISTICS"
  }, {
    name: "MANUFACTURING"
  }, {
    name: "TECH STARTUPS"
  }, {
    name: "EDUCATION"
  }, {
    name: "GOVERNMENT"
  }, {
    name: "ENERGY"
  }, {
    name: "HOSPITALITY"
  }, {
    name: "MEDIA"
  }, {
    name: "TELECOM"
  }, {
    name: "PHARMACEUTICALS"
  }, {
    name: "NON-PROFIT"
  }];
  const marqueeItems = [...secondaryClients, ...secondaryClients];
  return <section data-section-id="5026" id="sector-expertise" className="bg-background text-foreground py-32 px-4 overflow-hidden">
      <div ref={ref} className={`max-w-7xl mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
        {}
        <div className="flex items-center justify-center gap-6">
          <div className="hidden sm:block h-px w-[60px] bg-foreground/20" />
          <span className="font-mono text-xs tracking-[0.25em] uppercase text-[color:var(--primary)]">
            Industries Served
          </span>
          <div className="hidden sm:block h-px w-[60px] bg-foreground/20" />
        </div>

        {}
        <p className="mt-6 mx-auto text-center font-default italic text-2xl md:text-[28px] leading-snug text-foreground/80" style={{
        maxWidth: "600px"
      }}>
          Securing the digital infrastructure of modern enterprises across every sector.
        </p>

        {}
        <div className="mt-20">
          <div className="grid grid-cols-3 md:flex md:flex-wrap md:items-center md:justify-center gap-y-12 md:gap-x-20">
            {primaryLogos.map((logo, i) => <div data-index={i} key={logo.name} className="group flex items-center justify-center">
                <img src={logo.src} data-wvc-srcset={logo.srcset} data-wvc-sizes={logo.sizes} alt={logo.name} loading="lazy" decoding="async" className="h-8 md:h-10 w-auto object-contain opacity-40 transition-all duration-[400ms] ease-out group-hover:opacity-100 group-hover:[filter:drop-shadow(0_0_12px_var(--primary))]" />
              </div>)}
          </div>
        </div>

        {}
        <div className="relative mt-20">
          {}
          <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-0 w-24 z-10" style={{
          background: "linear-gradient(to right, var(--background), hsla(0,0%,0%,0))"
        }} />
          <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 right-0 w-24 z-10" style={{
          background: "linear-gradient(to left, var(--background), hsla(0,0%,0%,0))"
        }} />

          <div className="overflow-hidden">
            <div className="flex w-max marquee-track gap-16">
              {marqueeItems.map((item, i) => <span data-index={i} key={`${item.name}-${i}`} className="font-mono text-xs md:text-sm tracking-[0.2em] uppercase text-foreground/40 whitespace-nowrap">
                  {item.name}
                </span>)}
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes solace-marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .marquee-track {
          animation: solace-marquee 30s linear infinite;
        }
        @media (prefers-reduced-motion: reduce) {
          .marquee-track { animation: none; }
        }
      `}</style>
    </section>;
}